// extracted by mini-css-extract-plugin
export default {"link":"Z6I9qa","arrow":"uflXmn","linkWrapper":"jrvWYl","active":"oq03gt"};